import Cookies from 'js-cookie';

export const init = () => { // eslint-disable-line import/prefer-default-export
  detectFormSuccess();
  dismissPopup();
  showPopup();
};

const detectFormSuccess = () => {
  const newsletterPopup = [...document.getElementsByClassName('newsletter-popup-wrapper')];
  if (!newsletterPopup.length || Cookies.get('modalDismissed') === 'dismissed') {
    return false;
  }

  const formID = newsletterPopup[0].getElementsByClassName('v65-form')[0].id;
  if (localStorage[`popupForm${formID}`] !== undefined) {
    return false;
  }

  window.addEventListener('v65-formSubmission', (event) => {
    const formId = event.detail.id;
    const formResponse = event.detail.response;

    if (formResponse.includes('method="post"')) {
      localStorage[`popupForm${formId}`] = 'submitted';
    }

    $('html, body').stop(); // Stop jQuery animation from Vin65
  }, false);

  return newsletterPopup;
};

const dismissPopup = () => {
  const newsletterPopup = [...document.querySelectorAll('.newsletter-popup-wrapper .v65-pod')];
  if (!newsletterPopup.length) {
    return false;
  }

  const closeNewsletterPopup = document.createElement('div');
  closeNewsletterPopup.className = 'newsletter-popup-wrapper__close';
  newsletterPopup[0].appendChild(closeNewsletterPopup);

  ['touchstart', 'click'].forEach(event => closeNewsletterPopup.addEventListener(event, (e) => {
    e.preventDefault();
    newsletterPopup[0].parentElement.classList.remove('newsletter-popup-wrapper--visible');
    Cookies.set('modalDismissed', 'dismissed', { expires: 7 });
  }, false));

  return newsletterPopup;
};

const showPopup = () => {
  const newsletterPopup = [...document.getElementsByClassName('newsletter-popup-wrapper')];
  if (!newsletterPopup.length || Cookies.get('modalDismissed') === 'dismissed') {
    return false;
  }

  const formID = newsletterPopup[0].getElementsByClassName('v65-form')[0].id;
  if (localStorage[`popupForm${formID}`] !== undefined) {
    return false;
  }

  setTimeout(() => {
    newsletterPopup[0].classList.add('newsletter-popup-wrapper--visible');
  }, 10000);

  return newsletterPopup[0];
};



// WEBPACK FOOTER //
// ./src/assets/js/newsletterPopup.js